import { AnyStateWithExchange } from '../types';

export const getPaymentStatusState = (state: AnyStateWithExchange) => state.exchange.paymentStatus;
